import React, { Component } from "react";
import { connect } from "react-redux";
import Branding from "./Branding";
import MainNav from "./MainNav";
import { withTranslation } from 'react-i18next';
import ToolBar from "../components/ToolBar";
import LoadingBar from "react-redux-loading-bar";

class AppHeader extends Component {
    render() {
        const { isCatalogueMode, showOpenpayBanner, showKlarnaBanner, allowAnonymouse } = this.props.settings;
       
        if (isCatalogueMode === true) {
            return (
                <header className="navbar-Catalogue">
                    <LoadingBar className="progress progress-bar" showFastActions />
                    <ToolBar settings={this.props.settings} />
                </header>
            );
        }
        const { user } = this.props;
        if (allowAnonymouse === false && user.isAuthenticated !== true)
            return (
                <header className="navbar-Catalogue">
                    <LoadingBar className="progress progress-bar" showFastActions />
                </header>
            );
        
        return (
            <header className={showOpenpayBanner || showKlarnaBanner ? "navbar navbar-sticky navbar-second" : "navbar navbar-sticky" }>
                <Branding />
                <MainNav />
                <LoadingBar className="progress progress-bar" showFastActions />
                <ToolBar settings={this.props.settings} />
            </header>
    );
  }
}

function mapStateToProps({ user, settings }, ownProps) {
    return { user, settings, ...ownProps };
}

export default withTranslation()(connect(mapStateToProps, null)(AppHeader));
